import React, { useContext, useEffect, useState } from 'react';
import { Avatar, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Typography, IconButton,Button} from '@mui/material';
import { Search as SearchIcon, ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import axios from 'axios';
import { ContextData } from '../../../context/Context';
import baseUrl from '../../../BaseURL'; 
import AddUserDialog from '../Contents/AdminUser/AddAdminUserDialog';
import SetPaymentRegisterForm from '../Contents/SetScholarship/SetPaymentRegisterForm';
import Loader from '../../../routes/Loader';
import { toast } from 'react-toastify';
import PopupDialog from '../../PopupDialog/PopupDialog';
/* import EditStudentPop from './PopDialogue/Student/EditStudentPop';
 */

const SetScholarship = () => {

  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [StudentData, setStudentData] = useState(null);
  const [CountData, setCountData] = useState(0);
  const rowsPerPage = 6;
  const {  AdministratorTokens, RefreshUesFF,GlobalLoader } = useContext(ContextData);
  const [OpenLoader,setOpenLoader] = useState(false)
  const [ReLoader,setReLoader] = useState(false)
   

  useEffect(() => {
    async function FetchData() {
      try {
        const response = await axios.get(`${baseUrl}/auth/get_scholarship_list_applicant`, {
          withCredentials: true,
          headers: {
            'Accept': 'application/json',
            'authorization': `Bearer ${AdministratorTokens !== null && AdministratorTokens}`
          }
        });

        setCountData(Object.keys(response.data));
        setStudentData(response.data);
       

      } catch (err) {
        if (err) console.log(err.message);
      }
    }
    FetchData();
  }, [ReLoader,GlobalLoader]);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const List = Object.keys(StudentData !== null && StudentData).map(data => StudentData[data]);
  const filteredUsers = List.filter(user => {
    const lowerCaseSearchText = searchText.toLowerCase().trim();
    return (
      user.qualification_type.toLowerCase().includes(lowerCaseSearchText)
    );
  });

  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const indexOfLastUser = currentPage * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;
  const usersToShow = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const handleNextPage = () => {
    setCurrentPage(prevPage => prevPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage(prevPage => prevPage - 1);
  };

  const HanldeRemove = async (tokens) => {
     
    setOpenLoader(true)

    try {
      const response = await axios.delete(`${baseUrl}/auth/remove_scholarship/${tokens}`, {
        withCredentials: true,
        headers: {
          'Accept': 'application/json',
          'authorization': `Bearer ${AdministratorTokens !== null && AdministratorTokens}`
        }
       
      }
       
    )
    toast.success(response.data)
    
    setOpenLoader(false)
    setReLoader(!ReLoader)

    } catch (err) {
      setOpenLoader(false)
      if (err) console.log(err.message);
    }




  }

  return (
    <div className="con-dev" style={{ width: "100%", height: "100%" }}>
      <Loader
      OpenLoader={OpenLoader}
       />
      <Container>
        <Typography variant="h4" gutterBottom className='flex justify-between items-center'>
          <p className='font-extrabold mt-3'>Set Scholarship</p>
          <div>
            <SetPaymentRegisterForm />
          </div>
        </Typography> 

        <TextField
          label="Search"
          variant="outlined"
          value={searchText}
          onChange={handleSearchChange}
          InputProps={{
            endAdornment: (
              <IconButton>
                <SearchIcon />
              </IconButton>
            ),
          }}
          fullWidth
          margin="normal"
        />
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ background: "rgb(0, 24, 69)" }}>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>No</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Scholarship Name</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Scholarship Type</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Qualification Type</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Residential Type</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Will Pay</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Amount to Pay</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Description</TableCell>
                <TableCell align='center' sx={{ color: "white", fontWeight: "800" }}>Remove</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {usersToShow.map((user, index) => (
                <TableRow key={user.id}>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{index + 1}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.scholarship_name}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.scholarship_type}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.qualification_type}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.resdential_type}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.will_pay}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}>{user.amount_to_pay}</TableCell>
                  <TableCell align='center' sx={{ whiteSpace: "nowrap" }}><PopupDialog type="set_scholarship" value={user.scholarship_description} /></TableCell>
                  <TableCell align='center'>
                    <Button className='Hover-' onClick={() => HanldeRemove(user.schl_token)} elevation={10} sx={{ whiteSpace: 'nowrap', fontSize: '14px', backgroundColor: 'rgb(199, 1, 1)', margin: '9px 0px' }} size="large" variant="contained">
                      Remove
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {totalPages > 1 && (
          <div>
            {currentPage > 1 && (
              <Button className='Hover-' onClick={handlePrevPage} elevation={10} sx={{ whiteSpace: 'nowrap', fontSize: '14px', backgroundColor: 'rgb(0, 24, 69)', color: "white", margin: '9px 4px' }} size="large" variant="contained">
                <ArrowBackIcon />
              </Button>
            )}
            <span>Page {currentPage} of {totalPages}</span>
            {currentPage < totalPages && (
              <Button className='Hover-' onClick={handleNextPage} elevation={10} sx={{ whiteSpace: 'nowrap', fontSize: '14px', backgroundColor: 'rgb(0, 24, 69)', color: "white", margin: '9px 4px' }} size="large" variant="contained">
                <ArrowForwardIcon />
              </Button>
            )}
          </div>
        )}
      </Container>
    </div>
  );
};

export default SetScholarship;


// get_data_adminuser